export function GetUserIdFromStorage() 
{
    var userId = window.localStorage.getItem("activeUserId");
    return userId != null ? userId : "";
}